import { Dates } from 'helpers';
import {
  getSearches,
  addSearch,
  updateSearch,
  deleteSearch,
} from 'services/carriers';
import {
  AdvancedSearchFormValues,
  AdvancedSearchReduxFunctions,
} from 'services/search';
import { PaginationDirection } from 'services/url';
import { Column, ColumnTypes } from 'ui/components/Table/ItemsTable';

export const advancedSearchReduxActions: AdvancedSearchReduxFunctions = {
  add: addSearch,
  delete: deleteSearch,
  update: updateSearch,
  get: getSearches,
};

export const CARRIER_COLUMNS = (date: Dates): Column[] => {
  const resolveDateColumn = (): Column => {
    switch (date) {
      case Dates.DateLastModified:
        return {
          title: 'Date Last Modified',
          field: Dates.DateLastModified,
          sortable: true,
          type: ColumnTypes.renderByCustomRow,
          searchable: false,
        };
      default:
        return {
          title: 'Date Created',
          field: Dates.DateCreated,
          sortable: true,
          type: ColumnTypes.renderByCustomRow,
          searchable: false,
        };
    }
  };

  return [
    {
      title: 'Name',
      field: 'name',
      sortable: true,
      type: ColumnTypes.renderByCustomRow,
    },
    {
      title: 'Description',
      field: 'description',
      sortable: true,
      type: ColumnTypes.renderByCustomRow,
    },
    resolveDateColumn(),
  ];
};

export const CARRIER_COLUMNS_SMALL: Column[] = [
  {
    title: 'Name',
    field: 'name',
    type: ColumnTypes.renderByCustomRow,
  },
];

export const displayNameMap = {
  'carrierServices.name': 'Carrier Service Name',
  name: 'Name',
  description: 'Description',
  SCAC: 'SCAC',
  deleted: 'Deleted',
};

export const initialCarriersFormValues: AdvancedSearchFormValues = {
  name: null,
  description: null,
  SCAC: null,
  'carrierServices.name': null,
  deleted: null,
};

export const initialPagination = {
  page: 1,
  pageSize: 25,
  sort: {
    sortBy: 'dateLastModified',
    direction: PaginationDirection.Descending,
  },
  totalRows: 25,
};
